<template>
    <div>
        <div class="content">
            <p class="notification">系统通知</p>
            <el-divider></el-divider>
            <div v-for="item in notificationlist" :key="item.index">
                <div class="notificationcontent">
                    <img src="@/assets/img/systemlogo.png" class="avatar" />
                    <div class="rightcontent">
                        <div class="top">
                            <p class="name">{{item.title}}</p>
                            <p class="time">{{item.created}}</p>
                        </div>
                        <p class="query">{{item.text}}</p>
                        <a class="query" :href="item.url">详情请戳：{{item.url}}</a>
                    </div>
                </div>
                <el-divider></el-divider>
            </div>
            <el-pagination
                background
                layout="jumper, prev, pager, next, slot, total"
                :total="total"
                :current-page="page"
                @current-change="currentChange"
                @prev-click="prevClick"
                @next-click="nextClick"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                notificationlist: [],
                total: 0,
                page: 1
            };
        },
        mounted() {
            this.getnoticelist();
        },
        methods: {
            getnoticelist() {
                this.httpGet(this.$root.getMessageList, {
                    page: this.page
                })
                    .then(result => {
                        // this.notificationlist = result.data;
                        if (result.count) {
                            this.notificationlist.push(...result.data);
                            this.total = Number(result.count);
                        } else {
                            this.notificationlist = [];
                            this.total = 0;
                        }
                        console.log(result, 111);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },

            currentChange(page) {
                console.log('currentChange', page);
                this.page = page;
                this.notificationlist = [];
                this.getnoticelist();
            },
            prevClick(page) {
                console.log('currentChange1', page);
                this.page = page;
                this.notificationlist = [];
                this.getnoticelist();
            },
            nextClick(page) {
                console.log('currentChange2', page);
                this.page = page;
                this.notificationlist = [];
                this.getnoticelist();
            }
        }
    };
</script>
<style lang="stylus"  rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .content {
        background-color: white;
        border-radius: 8px;
        width: 832px;
        padding: 24px;
        box-sizing: border-box;

        .notification {
            font-size: 16px;
            margin-left: 24px;
        }

        .notificationcontent {
            display: flex;
            flex-direction: row;

            .avatar {
                width: 48px;
                height: 48px;
                border-radius: 50px;
                margin-left: 24px;
            }

            .rightcontent {
                display: flex;
                flex-direction: column;

                .top {
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    .name {
                        font-size: 16px;
                        margin-left: 24px;
                    }

                    .time {
                        font-size: 12px;
                        opacity: 0.45;
                        margin-left: 16px;
                    }
                }

                .query {
                    font-size: 14px;
                    opacity: 0.85;
                    margin-left: 24px;
                    margin-top: 18px;
                    width: 560px;
                    color: #333;
                }
            }
        }
    }

    >>>.el-pagination {
        flex-center();
        padding: 20px;
        background: white;
    }
</style>
